import React from 'react';
import { ReactQueryDevtools } from 'react-query-devtools';
import { Provider } from 'react-redux';
import '../../global/styles/normalize.scss';
import { BrowserRouter } from 'react-router-dom';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import * as Colors from '@material-ui/core/colors';
import * as LayoutWrapper from 'cbs-layout-wrapper';
import { store } from '../../global';
import { Notifications } from '../notifications/notifications';
import { ErrorBoundary } from '../error-boundary/error-boundary';
import { PageLoader } from '../../packages/page-loader/page-loader';
import { SharedLink } from '../shared-link/shared-link';
import { Routes } from './components/routes';
import { AppNavigation } from './components/navigation/navigation';
import { Auth } from './components/auth/auth';

const theme = createMuiTheme({
  typography: {
    fontFamily: "'Poppins', 'Roboto', sans-serif",
  },
  breakpoints: {},
  palette: {
    primary: Colors.lightGreen,
    error: Colors.deepOrange,
    info: {
      50: 'rgba(7, 160, 195, 0.04)',
      100: 'rgba(7, 160, 195, 0.06)',
      200: 'rgba(7, 160, 195, 0.08)',
      300: 'rgba(7, 160, 195, 0.16)',
      400: 'rgba(7, 160, 195, 0.24)',
      500: '#5dd1f6',
      600: 'rgba(7, 160, 195, 0.48)',
      700: 'rgba(7, 160, 195, 0.64)',
      800: 'rgba(7, 160, 195, 0.80)',
      900: 'rgba(7, 160, 195, 0.92)',
    },
  },
});

export const App = () => (
  <MuiThemeProvider theme={theme}>
    <Provider store={store}>
      <React.Suspense fallback={<PageLoader />}>
        <Auth>
          <BrowserRouter>
            <ErrorBoundary>
              <AppNavigation />

              <Routes />

              <Notifications />
              <LayoutWrapper.Banner />
              <LayoutWrapper.Footer LinkComponent={SharedLink} />
            </ErrorBoundary>
          </BrowserRouter>
        </Auth>
      </React.Suspense>

      <ReactQueryDevtools />
    </Provider>
  </MuiThemeProvider>
);
